import { render, staticRenderFns } from "./dataDesign.vue?vue&type=template&id=230a8024&scoped=true"
import script from "./dataDesign.vue?vue&type=script&lang=js"
export * from "./dataDesign.vue?vue&type=script&lang=js"
import style0 from "./dataDesign.vue?vue&type=style&index=0&id=230a8024&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a8024",
  null
  
)

export default component.exports